import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store, Action } from '@ngrx/store';
import { State } from '@dwo/reducers';
import { ResourceEffect } from '@app/core/store/effects/resource.effect';
import { DocumentsService } from '@app/core/services/documents.service';
import { DocumentActionTypes, LoadDocuments, LoadDocumentsSuccess } from '@dwo/actions';
import { Observable } from 'rxjs';

@Injectable()
export class DocumentsEffect extends ResourceEffect {
  constructor(
    readonly actions$: Actions,
    readonly documentsService: DocumentsService,
    readonly store: Store<State>,
  ) {
    super(actions$, documentsService, store);
  }

  loadDocuments$ = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType<LoadDocuments>(DocumentActionTypes.LoadDocuments),
        this.fetchResource('loadWorkOrderDocuments', LoadDocumentsSuccess, (action: LoadDocuments) => [
          action.workOrderId,
        ]),
      ),
  );
}
